import { Link } from "react-router-dom";

import { t } from "@/i18n/es";

export function NotFound() {
  return (
    <main className="flex min-h-app flex-col items-center justify-center bg-graphite p-6 text-bone">
      <p className="text-sm uppercase tracking-widest text-gray-mid">404</p>
      <h1 className="mt-4 text-2xl font-medium">{t.notFound.title}</h1>
      <Link
        to="/"
        className="mt-8 rounded-md border border-border-subtle px-4 py-2 text-sm text-bone-muted transition-colors duration-fast hover:border-border-strong hover:text-bone"
      >
        {t.notFound.cta}
      </Link>
    </main>
  );
}
